export default __webpack_public_path__ + "static/media/Hangman.287aadf5.svg";